import { flattenToStructuredList } from "./responseFlattener";

function collectLeafFields(item) {
  const out = [];
  const walk = (cur) => {
    if (cur.isExpandable) {
      cur.children?.forEach(walk);
    } else {
      out.push({
        container: cur.container,
        key: `${cur.container}_${cur.key}`,
        path: cur.path,
        value: cur.value,
      });
    }
  };
  walk(item);
  return out;
}

export function autoSelectSingleItemFields(
  data,
  { locale = "ru", participantTypeCode, serviceCode } = {}
) {
  if (!data || typeof data !== "object" || Array.isArray(data)) return [];

  const structured = flattenToStructuredList(data, { locale });
  const raw = [];

  for (const item of structured) {
    if (item.type !== "array") continue;
    if (!item.children || item.children.length !== 1) continue;

    const child = item.children[0];
    if (child.isExpandable) {
      raw.push(...collectLeafFields(child));
    } else {
      raw.push({
        container: child.container,
        key: child.key,
        path: child.path,
        value: child.value,
      });
    }
  }

  return raw
    .map((f) => ({
      key: f.key,
      value: f.value,
      participant_type_code: participantTypeCode,
      service_code: serviceCode,
    }))
    .filter(
      (f) =>
        f.key &&
        f.value !== undefined &&
        f.value !== "" &&
        f.service_code &&
        f.participant_type_code
    );
}
